export const AD_CLIENT = "ca-pub-XXXXXXXXXXXXXXXX";
